<template>
    <div class="row py-4" v-if="loading">
        <div class="col-12 d-flex justify-content-center">
            <Loading />
        </div>
    </div>
    <div id="publications-app" v-else>
        <div class="d-none" id="app-top"></div>
        <div class="row">
            <div class="col-12">
                <Filters />
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <Listing />
                <Pagination />
            </div>
        </div>
    </div>
</template>

<script>
import Loading from '@/components/Loading';
import Listing from '@/views/Listing';
import Filters from '@/components/Filters';
import Pagination from '@/views/Pagination';
import dayjs from 'dayjs';

export default {
    name: 'App',
    components: {
        Loading,
        Listing,
        Filters,
        Pagination,
    },
    data() {
        return {
            loading: true,
        };
    },
    beforeMount() {
        function findMatchInArray(query, array, property) {
            let match = false;

            for (let i = 0; i < array.length; i++) {
                const item = array[i];

                if (query == item[property]) {
                    match = { item, index: i };
                    break;
                }
            }

            return match;
        }

        this.loading = true;

        this.$store.dispatch('getMetaFields').then(() => {
            this.loading = false;
            const urlQueryString = Object.assign({}, window.urlQueryString);
            /*
                        We have to update filters based on the url query string
                        To whomever reads this: I'm sorry.

                        We're doing an array intersection combined with match checks
                        so get ready to see nested for loops with conditions inside
                        of them.

                        I'll document what's going on so this isn't so insane.
                    */

            // If there are url query items, loop through and update filters accordingly
            if (Object.keys(urlQueryString).length > 0) {
                for (let i = 0; i < Object.keys(urlQueryString).length; i++) {
                    const queryKey = Object.keys(urlQueryString)[i];

                    // We check to see if the query key is a filter (could just be utm or something)
                    const match = findMatchInArray(
                        decodeURIComponent(queryKey),
                        this.$store.getters.filters,
                        'name'
                    );

                    // If it's a filter, we check the type and dispatch the correct action
                    if (match) {
                        switch (match.item.type) {
                            case 'list': {
                                /*
                                    God help us. It's a list filter.
                                    We'll do a second Array search to find the matching option and then dispatch a toggle for it.

                                    We could buffer these at some point but remember that I already debounce list updates so the
                                    expensive operations are only executed once.
                                */

                                for (
                                    let j = 0;
                                    j < urlQueryString[queryKey].length;
                                    j++
                                ) {
                                    const value = decodeURIComponent(
                                        urlQueryString[queryKey][j]
                                    );
                                    const matchedValue = findMatchInArray(
                                        value,
                                        this.$store.getters.filters[match.index]
                                            .value,
                                        'value'
                                    );

                                    if (matchedValue) {
                                        this.$store.dispatch(
                                            'toggleListFilterItem',
                                            {
                                                filterIndex: match.index,
                                                optionIndex: matchedValue.index,
                                                updateQuery: false,
                                            }
                                        );
                                    }
                                }

                                break;
                            }

                            case 'date': {
                                this.$store.dispatch('updateFilterValue', {
                                    filterIndex: match.index,
                                    value: dayjs(
                                        urlQueryString[queryKey][0],
                                        'YYYY-MM-DD'
                                    ),
                                    updateQuery: false,
                                });
                                break;
                            }

                            default: {
                                this.$store.dispatch('updateFilterValue', {
                                    filterIndex: match.index,
                                    value: urlQueryString[queryKey][0],
                                    updateQuery: false,
                                });
                                break;
                            }
                        }
                    }
                }

                this.scrollToUpcoming = true;
            }
        });
    },
};
</script>

<style lang="scss">
@import 'styles/index';
</style>
